// src/CategoryTile.tsx
import { useTheme } from "@mui/material/styles/index.js";
import Box from "@mui/material/Box/index.js";
import Grid from "@mui/material/Grid/index.js";
import Typography from "@mui/material/Typography/index.js";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { jsx, jsxs } from "react/jsx-runtime";
var CategoryTile = ({ category }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const childrenIdsString = ("Children" in category ? category.Children : void 0)?.map((child) => child.id).join(",") || ("childrenIds" in category ? category.childrenIds : void 0)?.map((child) => child.id).join(",") || "";
  const goDeeper = () => {
    if (category.isLeaf) {
      navigate(`/products/${category.name}/list`);
    } else if (childrenIdsString) {
      navigate(`/products/${childrenIdsString}`);
    }
  };
  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };
  return /* @__PURE__ */ jsx(
    Grid,
    {
      item: true,
      xs: 12,
      sm: 6,
      md: 3,
      component: motion.div,
      initial: "hidden",
      whileInView: "visible",
      viewport: { once: true },
      animate: "visible",
      variants,
      transition: { duration: 0.5 },
      children: /* @__PURE__ */ jsxs(Box, { children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            onClick: goDeeper,
            style: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              borderRadius: "8px",
              overflow: "hidden",
              transition: "transform 0.3s ease-in-out",
              height: "220px",
              position: "relative"
            },
            onMouseOver: (e) => e.currentTarget.style.transform = "scale(1.05)",
            onMouseOut: (e) => e.currentTarget.style.transform = "scale(1)",
            children: /* @__PURE__ */ jsx(
              "img",
              {
                loading: "lazy",
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                  objectPosition: "center"
                },
                src: category.imageSrc ? category.imageSrc : "/assets/niezdjecie.png",
                alt: category.name
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(Box, { marginTop: 1, children: /* @__PURE__ */ jsx(
          Typography,
          {
            onClick: goDeeper,
            color: theme.palette.text.primary,
            fontWeight: 700,
            variant: "h6",
            sx: { cursor: "pointer" },
            children: category.name
          }
        ) })
      ] })
    },
    category.id
  );
};
export {
  CategoryTile
};
